import { render } from "./MiniDashboardHeader.vue?vue&type=template&id=2438f35e&scoped=true&ts=true"
import script from "./MiniDashboardHeader.vue?vue&type=script&lang=ts"
export * from "./MiniDashboardHeader.vue?vue&type=script&lang=ts"

import "./MiniDashboardHeader.vue?vue&type=style&index=0&id=2438f35e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2438f35e"]])

export default __exports__